import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchFirm = () => api.get("/firm").then((r) => r.data);
export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchService = (slug) => api.get(`/services/${slug}`).then((r) => r.data);
export const fetchTeam = () => api.get("/team").then((r) => r.data);
export const fetchInsights = () => api.get("/insights").then((r) => r.data);
export const fetchInsight = (slug) => api.get(`/insights/${slug}`).then((r) => r.data);
